export const StoreRoute = {
    Landing:
        '/',
    Category:
        '/category/:id',
    Search:
        '/search/:keyword',
    Orders:
        '/orders',
    OrderError:
        '/orders/error',
    OrderView:
        '/orders/:key',
    OrderPay:
        '/orders/:key/pay',
};
